<template>
  <div>
    <h2 class="p-name d-flex align-items-center mt-4">
      <BaseIcon name="folder" :width="24" :height="24" />
      {{ name }}
    </h2>
    <div class="card-body-track">
      <div v-if="projectTracks.length > 0">
        <div class="d-flex flex-row mb-3 pb-2 border-white">
          <div class="col-1"></div>
          <div class="col-6 pl-0 card-accent-text sortHeader">Name</div>
          <div
            class="col-0 col-sm-0 col-md-0 col-lg-2 col-xl-2 d-sm-none d-md-none d-none d-lg-block d-xl-block card-accent-text sortHeader"
          >
            Date
          </div>
          <div
            class="col-3 col-sm-3 col-md-3 col-lg-1 col-xl-1 card-accent-text sortHeader"
          >
            Status
          </div>
          <div class="col-2"></div>
        </div>
        <div v-for="track in projectTracks" :key="track.id">
          <trackItem
            class="trackText pl-3 my-2"
            :name="track.trackname"
            :id="track.id"
            :category="track.category"
            :trackStyle="track.style"
            :mixid="track.mixids"
            :trackStatus="track.status"
            :timestamp="track.timestamp"
          />
        </div>
      </div>
      <div class="trackText pl-3" v-else>No tracks in this project.</div>
    </div>
  </div>
</template>

<script>
import TrackItem from "@/components/TrackItem.vue";

export default {
  components: {
    TrackItem,
  },
  props: {
    name: String,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    projectTracks() {
      if (this.$store.state.apiEvents.userTracks != null) {
        return this.$store.state.apiEvents.userTracks.filter((item) => {
          return item.projectname == this.name;
        });
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.trackText {
  color: #fff;
  font-size: 15px;
  font-family: "Open Sans";
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
.p-name {
  text-transform: uppercase;
  font-size: 24px;
}
</style>
